import "../../../assets/styles/feedbackForm.css";
import { useState, useEffect } from "react";
import { Group } from "../../../components";
import {useTheme} from "../../../hooks";



const negativeTags = [
    "Lengthy submission process",
    "Complex documentation",
    "Unclear instructions",
    "System errors",
    "Slow processing",
    "Upload difficulties",
    "Payment issues",
    "Status unclear",
    "Complicated navigation",
    "Technical problems"
];

const positiveTags = [
    "Quick submission",
    "Clear instructions",
    "Easy upload",
    "Smooth payment",
    "Fast approval",
    "Helpful guidance",
    "Easy tracking",
    "Intuitive interface",
    "Reliable system",
    "Time-saving"
];

export function FeedbackForm({ onChange, processName = "this Process" }: {
    onChange: (rating: number, comment: string, tags: string[]) => void;
    processName?: string;
}) {
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState("");
    const [selectedTags, setSelectedTags] = useState<string[]>([]);
    const [isVisible, setIsVisible] = useState(false);
    const { theme } = useTheme();

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 100);
        return () => clearTimeout(timer);
    }, [theme]);

    const handleChange = (r = rating, c = comment, t = selectedTags) => {
        onChange(r, c, t);
    };

    const toggleTag = (tag: string) => {
        const newTags = selectedTags.includes(tag) ? selectedTags.filter(t => t !== tag) : [...selectedTags, tag];
        setSelectedTags(newTags);
        handleChange(rating, comment, newTags);
    };

    const renderTags = () => {
        const tags = rating >= 1 && rating <= 3 ? negativeTags : rating >= 4 ? positiveTags : [];
        if (!tags.length) return null;
        const prompt = rating <= 3 ? "What challenges did you face?" : "What worked well for you?";
        return (
            <div className="feedback-tags-container">
                <p className="tags-prompt">{prompt}</p>
                <div className="feedback-tags">
                    {tags.map(tag => (
                        <button
                            key={tag}
                            className={`tag-button ${selectedTags.includes(tag) ? "selected" : ""}`}
                            onClick={() => toggleTag(tag)}
                            type="button"
                        >
                            {tag}
                        </button>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className={`tra-container ${theme.isDark === 'true' ? 'dark-theme' : ''}`}>
            <div className={`animated-header ${isVisible ? "visible" : ""}`}>
                <div className="animation-container">
                    {/*<div className="balloon balloon-1">🎈</div>*/}
                    {/*<div className="balloon balloon-2">🎈</div>*/}
                    {/*<div className="balloon balloon-3">🎈</div>*/}
                    {/*<div className="balloon balloon-1">🎈</div>*/}
                    {/*<div className="balloon balloon-2">🎈</div>*/}
                    {/*<div className="balloon balloon-3">🎈</div>*/}

                    <div className="message-banner">
                        <span className="icon">💬</span>
                        <span className="text uppercase">
                A place where your voice shapes better service.
            </span>
                        <span className="icon">💬</span>
                    </div>
                </div>
            </div>


            <div className="tra-card">
                <div className="card-header">
                    <h1 className="card-title">Feedback</h1>
                    <p className="card-subtitle">How was your experience with {processName}?</p>
                </div>

                <div className="tra-section">
                    <div className="feedback-stars">
                        {[1, 2, 3, 4, 5].map((star) => {
                            let colorClass = "";
                            if (rating >= 4 && star <= rating) colorClass = "blue";
                            else if (rating >= 1 && rating <= 3 && star <= rating) colorClass = "red";

                            return (
                                <span
                                    key={star}
                                    className={`star ${colorClass}`}
                                    onClick={() => {
                                        setRating(star);
                                        handleChange(star, comment, selectedTags);
                                    }}
                                >
          ★
        </span>
                            );
                        })}
                    </div>
                </div>


                {renderTags()}

                <div className="tra-section">
                    {/*<textarea*/}
                    {/*    placeholder="Share your experience..."*/}
                    {/*    value={comment}*/}
                    {/*    onChange={e => { setComment(e.target.value); handleChange(rating, e.target.value, selectedTags); }}*/}
                    {/*/>*/}
                    <Group.Control
                        placeholder="Share your experience..."
                        type="textarea"
                        value={comment}
                        size={"full"}
                        controlSize={10}
                        onChange={(value) => { // value is passed directly, not as e.target.value
                            setComment(value);
                            handleChange(rating, value, selectedTags);
                        }}
                        rows={4}
                    />
                </div>
            </div>
        </div>
    );
}